module.exports = __webpack_public_path__ + "media/localization/polish-50537fb1.png";